import appleLogo from "@/assets/apple-logo.svg";
import googleLogo from "@/assets/google-logo.svg";
import { Button } from "@/components/ui/button";
import { isAppleSignInAvailable } from "@/lib/platform";
import { useAuthStore } from "@/store/authStore";

/**
 * Apple + Google buttons, shared by the sign-in and signup sheets so the two
 * stay visually identical. Apple is hidden on Android (`isAppleSignInAvailable`)
 * and always leads, matching platform convention.
 *
 * `inviteCode` is threaded into the OAuth redirect on the signup path so the
 * account is created against the invite; sign-in omits it.
 */
export function OAuthButtons({ inviteCode }: { inviteCode?: string }) {
  const { signInWithGoogle, signInWithApple } = useAuthStore();
  const appleAvailable = isAppleSignInAvailable();

  return (
    <div className="flex flex-col gap-3">
      {appleAvailable ? (
        <Button
          type="button"
          className="h-13 w-full justify-center gap-3 rounded-xl bg-black text-[15px] font-semibold text-white hover:bg-black/90"
          onClick={() => void signInWithApple(inviteCode)}
        >
          <img src={appleLogo} alt="" className="h-5 w-5 invert" />
          Continue with Apple
        </Button>
      ) : null}

      <Button
        type="button"
        variant="outline"
        className="h-13 w-full justify-center gap-3 rounded-xl border-black/10 bg-white text-[15px] font-semibold hover:bg-white/70"
        onClick={() => void signInWithGoogle(inviteCode)}
      >
        <img src={googleLogo} alt="" className="h-5 w-5" />
        Continue with Google
      </Button>
    </div>
  );
}

/** Hairline "or" separator between the OAuth block and the email form. */
export function AuthDivider() {
  return (
    <div className="my-5 flex items-center gap-3">
      <span className="h-px flex-1 bg-black/10" />
      <span className="text-xs font-medium text-[#aeb5cb]">or</span>
      <span className="h-px flex-1 bg-black/10" />
    </div>
  );
}
